import axios from 'axios';
import config from '../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../core/modules/common/tools/URLTools';

const getDownloadReportResult = (reportName, execId, batchNo) => {
  const reportCode = reportName;
  const serviceUrl = constructServiceURL({
    endpoint: 'getDownloadReportResult',
    stub: config.useStubbedEndpoints,
    params: {
      reportCode,
      execId,
      batchNo,
    },
  });
  return axios.get(serviceUrl);
};

/**
 * The streamed download is fetched by the browser itself rather than by axios: the report is
 * written straight to disk, so it never passes through the page's memory and there is no batch
 * loop. Only the URL is built here.
 */
const streamedDownloadReportResultURL = (reportName, execId) => constructServiceURL({
  endpoint: 'getStreamedDownloadReportResult',
  stub: config.useStubbedEndpoints,
  params: {
    reportCode: reportName,
    execId,
  },
});

/**
 * Asks whether the streamed download would be admitted before it is handed to the browser. The
 * browser owns that request, so its response never reaches the page; this is the only chance to
 * show why a download was refused.
 */
const checkStreamedDownload = (reportName, execId) => axios.get(constructServiceURL({
  endpoint: 'getStreamedDownloadReportCheck',
  stub: config.useStubbedEndpoints,
  params: {
    reportCode: reportName,
    execId,
  },
}));

export default { getDownloadReportResult, streamedDownloadReportResultURL, checkStreamedDownload };
